import { useNavigate } from "react-router-dom";
import { HiOutlineExclamationTriangle } from "react-icons/hi2";
import { Button } from "../../components";

export default function ErrorPage() {
  const navigate = useNavigate();
  return (
    <div className='bg-white min-h-[90dvh] px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8'>
      <div className='max-w-max mx-auto text-center'>
        <main className='flex flex-col items-center'>
          <HiOutlineExclamationTriangle className='h-16 w-16 text-red-500' />
          <h1 className='mt-4 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl'>
            Something went wrong
          </h1>
          <p className='mt-2 text-base text-gray-500'>
            An unexpected error occurred. Please try again, and contact support if the problem persists.
          </p>
          <div className='mt-10 flex space-x-3'>
            <Button
              label='Go back to dashboard'
              onClick={() => navigate("/dashboard", { replace: true })}
            />
            <Button
              label='Reload page'
              buttonType='secondary'
              onClick={() => window.location.reload()}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
